<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 20 20">
    <g clip-path="url(#clip0_6892_8948)">
      <path
        d="M20 18.8235V20H0V18.8235H20ZM15.7059 10.4118L14.8706 9.57647L10.5765 13.8706V0H9.4V13.8706L5.10588 9.57647L4.27059 10.4118L9.97647 16.1176L15.6824 10.4118H15.7059Z"
        :class="colorClass"
      />
    </g>
    <defs>
      <clipPath id="clip0_6892_8948">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
